export default "__VITE_ASSET__cCZqX014__"